import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  InputAdornment,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import {
  AccountCircle,
  MonetizationOn,
  FlightTakeoff,
  FlightLand,
  TransferWithinAStation,
  LocationOn
} from "@mui/icons-material";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {
  VIEW_SERVICE_LIST_FROM,
  EDIT_SERVICE
} from "../../component/common/Routes/AppRoutes";
import TextInputField from "../../component/ui/FormFields/TextInputField";
import CustomButton from "../../component/ui/FormFields/Button";
import StatusRadioGroup from "../../component/ui/FormFields/StatusRadioGroup";
import { useDispatch, useSelector } from "react-redux";
import {
  resetServiceDetails,
  serviceViewRequest,
  updateServiceApprovalRequest
} from "../../redux/Service/ServiceAction";
import { toast, ToastContainer } from "react-toastify";
import { useForm } from "react-hook-form";
import Loading from "../../component/ui/Loading";

export default function ViewService() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { serviceId } = useParams();
  useEffect(() => {
    dispatch(serviceViewRequest(serviceId));
  }, [serviceId, dispatch]);
  const service = useSelector((state) => state.services?.Service);
  const [initialStatus, setInitialStatus] = useState("");
  const user = useSelector((state) => state.auth.user);
  const serviceData = service?.data?.data?.data;

  const loading = service?.loading;
  const permissions = user?.permissions;
  const successMessage = service?.approvalMessage;
  const errorMessage = service?.error;
  const { control } = useForm();

  const approvalLoading = useSelector(
    (state) => state.services.Service.approvalLoading
  );

  const [approvalStatus, setApprovalStatus] = useState(
    serviceData?.approoved_status || null
  );

  useEffect(() => {
    if (serviceData) {
      setApprovalStatus(serviceData.approoved_status);
      setInitialStatus(serviceData.approoved_status);
    }
  }, [serviceData]);

  const handleApprovalStatusChange = (event) => {
    setApprovalStatus(parseInt(event.target.value));
  };

  const handleApprovalStatusSubmit = () => {
    dispatch(updateServiceApprovalRequest(serviceData.id, approvalStatus));
  };
  useEffect(() => {
    if (successMessage != " ") {
      toast.success(successMessage, {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: false,
        onClose: () => {
          dispatch(resetServiceDetails());
          navigate(VIEW_SERVICE_LIST_FROM);
        }
      });
    }
  }, [successMessage]);

  const showPendingOption = initialStatus === "2" || initialStatus === 2;

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: false
      });
      //  dispatch(resetServiceDetails())
    }
  }, [errorMessage]);
  // useEffect(() => {
  //   dispatch(resetServiceDetails());
  // }, []);
  if (loading) {
    return <Loading text={" Loading service details..."} />;
  }

  if (errorMessage) {
    return (
      <Typography variant="h6" align="center" color="error">
        {typeof errorMessage === "string"
          ? errorMessage
          : "Something went wrong while fetching service data."}
      </Typography>
    );
  }

  if (!serviceData) {
    return (
      <Typography variant="h5" color="error">
        No Service data found!
      </Typography>
    );
  }

  const fields = [
    {
      label: "Service",
      value: serviceData?.services || "-",
      icon: <AccountCircle />
    },
    {
      label: "Arrival/Departure",
      value:
        serviceData?.arrival_departure_type === 1
          ? "Arrival"
          : serviceData.arrival_departure_type === 2
          ? "Departure"
          : "Transit" || "-",
      icon: <TransferWithinAStation />
    },
    // {
    //   label: "Arrival",
    //   value: serviceData.arrival || "-",
    //   icon: <FlightLand />,
    //   multiline: true,
    //   rows: 4
    // },
    // {
    //   label: "Departure",
    //   value: serviceData.departure || "-",
    //   icon: <FlightTakeoff />,
    //   multiline: true,
    //   rows: 4
    // },
    // {
    //   label: 'Transit',
    //   value: serviceData.transit || '-',
    //   icon: <TransferWithinAStation />,
    // },
    {
      label: "Service Type",
      value:
        serviceData.service_type === 1
          ? "Domestic"
          : serviceData.service_type === 2
          ? "International"
          : "Both" || "-",
      icon: <TransferWithinAStation />
    }
  ];
  if (serviceData?.arrival_departure_type === 3) {
    fields.push({
      label: "Transit Service Type",
      value:
        serviceData?.transit_type === 2
          ? "Domestic To Domestic"
          : serviceData?.transit_type === 1
          ? "Domestic To International"
          : serviceData?.transit_type === 0
          ? "International To Domestic"
          : serviceData?.transit_type === 3
          ? "International To International"
          : "-",
      icon: <TransferWithinAStation />,
      sm: 6
    });
  }
  return (
    <>
      <ToastContainer />
      <Box sx={{ margin: "30px" }}>
        <Card>
          <CardContent sx={{ padding: 4 }}>
            <Typography variant="h5" className="form-heading" gutterBottom>
              View Service
            </Typography>
            <Grid container spacing={3} className="service-form-margin">
              {fields.map((field, index) => (
                <Grid
                  item
                  xs={12}
                  sm={
                    field.sm ||
                    (["Arrival", "Departure", "Transit"].includes(field.label)
                      ? 12
                      : 6)
                  }
                  key={index}
                >
                  <TextInputField
                    label={field.label}
                    value={field.value}
                    disabled={true}
                    multiline={field.multiline}
                    rows={field.rows}
                    startAdornment={
                      <InputAdornment position="start">
                        {field.icon}
                      </InputAdornment>
                    }
                  />
                </Grid>
              ))}
              {/* Status */}
              <Grid item xs={12} sm={6}>
                <StatusRadioGroup
                  name="status"
                  defaultValue={
                    serviceData.status === 1 ? "Active" : "Inactive"
                  }
                  control={control}
                  disabled={true}
                />
              </Grid>
              {user?.role === "Admin" && (
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Approval Status
                  </Typography>
                  <RadioGroup
                    value={approvalStatus}
                    onChange={handleApprovalStatusChange}
                    row
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio color="success" />}
                      label="Approved"
                    />
                    {showPendingOption && (
                      <FormControlLabel
                        value={2}
                        control={<Radio color="warning" />}
                        label="Pending"
                      />
                    )}
                    <FormControlLabel
                      value={3}
                      control={<Radio color="error" />}
                      label="Rejected"
                    />
                  </RadioGroup>
                  <CustomButton
                    variant="contained"
                    className="success-button"
                    text={"Submit Approval Status"}
                    loading={approvalLoading}
                    onClick={handleApprovalStatusSubmit}
                    disabled={approvalLoading}
                  />
                </Grid>
              )}
            </Grid>
            {/* Buttons */}
            <Box className="button-container" sx={{ marginTop: 4 }}>
              <CustomButton
                variant="contained"
                className="cancel-button"
                text="Back"
                onClick={() => {
                  dispatch(resetServiceDetails());
                }}
                link={VIEW_SERVICE_LIST_FROM}
              />
              {(permissions?.services?.edit || user?.user_type === 1) && (
                <CustomButton
                  variant="contained"
                  className="success-button"
                  text="Edit"
                  link={`${EDIT_SERVICE.replace(":serviceId", serviceId)}`}
                />
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
